// Module-level cache for per-child activity history on the Past Activities
// tab so re-clicking between child sub-tabs within a session doesn't refetch.
// Mutation sites (logChildActivity, updateChildActivity, child-tag reactions
// in NotificationCenter) invalidate the affected child's entry.

const cache = new Map(); // childId -> { data, ts }
const TTL_MS = 60_000;

export const getChildActivityHistoryCached = (childId) => {
  if (!childId) return null;
  const entry = cache.get(childId);
  if (!entry) return null;
  if (Date.now() - entry.ts > TTL_MS) {
    cache.delete(childId);
    return null;
  }
  return entry.data;
};

export const setChildActivityHistoryCached = (childId, data) => {
  if (!childId) return;
  cache.set(childId, { data, ts: Date.now() });
};

export const invalidateChildActivityHistoryCache = (childId) => {
  if (childId) cache.delete(childId);
  else cache.clear();
};
